import { RJExpressionNode } from "../expressions/RJExpressionNode";
import { EvaluationContext } from "./EvaluationContext";
import { EvaluationResult } from "./EvaluationResult";

export abstract class Evaluator
{
  context:EvaluationContext;

  abstract _evaluateNode( expression:RJExpressionNode ):EvaluationResult<any>;

  evaluate( expression:RJExpressionNode ):EvaluationResult<any>
  {
    return this._evaluateNode( expression );
  }

} 